<template>
    <b-tabs nav-id="dataset-type-tabs" tabs-id="dataset-type-tabs-content">

        <b-tab label="Data Set Type" id="dataset-type-tab"> <slot name="data-set-type-form" /> </b-tab>

        <b-tab label="Measurement Categories" id="categories-tab">
            <data-set-type-measurement-categories
                :items="categories"
                :user-permissions="userPermissions"
                :data-set-id="dataSetId" />
        </b-tab>

        <b-tab label="Measurements" id="measurements-tab">
            <data-set-type-measurements
                :items="measurements"
                :categories="categories"
                :user-permissions="userPermissions"
                :data-set-id="dataSetId" />
        </b-tab>

    </b-tabs>
</template>

<script>
export default {
    props: {

        categories: {
            type: Array,
            default: () => [],
        },

        measurements: {
            type: Array,
            default: () => [],
        },

        userPermissions: {
            type : Object,
            required : true
        },

        dataSetId: {
            type: Number,
            required: true,
        }

    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/measurements-module/data-set-type/DataSetTypeMeasurementsWrapper.vue